import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent, subscribeConsent, type ConsentState } from "@/lib/telemetry-consent";

export function TelemetryConsentBanner() {
  const [state, setState] = useState<ConsentState>("pending");

  useEffect(() => {
    setState(getConsent());
    return subscribeConsent(setState);
  }, []);

  if (state !== "pending") return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Consentement télémétrie"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground">
          Nous utilisons un outil de diagnostic d'erreurs (Sentry) pour améliorer la fiabilité de
          l'application. Cela peut inclure votre identifiant de session et l'URL visitée. Aucune
          donnée n'est envoyée sans votre accord.
        </p>
        <div className="flex gap-2 sm:shrink-0">
          <Button variant="ghost" size="sm" onClick={() => setConsent("denied")}>
            Refuser
          </Button>
          <Button size="sm" onClick={() => setConsent("granted")}>
            Autoriser
          </Button>
        </div>
      </div>
    </div>
  );
}